import Header from './components/Header';
import Hero from './components/Hero';
import Notices from './components/Notices';
import UniNews from './components/UniNews';
import Donate from './components/Donate';
import Footer from './components/Footer';
import Greeting from './components/Greeting';
import History from './components/History';
import Organization from './components/Organization';
import Location from './components/Location';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Greeting />
      <History />
      <Organization />
      <Location />
      <Notices />
      <UniNews />
      <Donate />
      <Footer />
    </div>
  );
}